import { defineMessages } from 'react-intl-next';

export const messages: {
	fetchErrorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	fetchErrorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	fetchErrorTitle: {
		id: 'company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.title',
		description: 'Title of flag shown when cover image from selected page cannot be fetched',
		defaultMessage: 'We can’t upload your image',
	},
	fetchErrorDescription: {
		id: 'company-hub.company-hub-common.link-cards.fetch-cover-image.fetch.error.description',
		description: 'Description of flag shown when cover image from selected page cannot be fetched',
		defaultMessage: 'Refresh the page and try again',
	},
});
